import ScrollReveal from './ScrollReveal'

export default function SectionHeading({ eyebrow, title, text, center = false }) {
  return (
    <ScrollReveal className={`section-head ${center ? 'center' : ''}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="gold-underline animate">{title}</h2>
      {text && <p style={{ marginTop: 18, fontSize: '1.05rem' }}>{text}</p>}
    </ScrollReveal>
  )
}
